import { IconButton, Stack } from '@mui/material';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BrokerRoutes } from '@energy-stacks/broker/shared';
import { IconPencil } from '@tabler/icons-react';
import { ESMenu, ESMenuItem } from '@energy-stacks/core/ui';
import { ChargingStationDetailsModel } from '@energy-stacks/broker/feature-charging-stations-data';
import { ChargingStationsActionsContext } from '../../ChargingStationsActionsContext';
// import { ClearAuthorizationCacheDialogV21 } from '../clear-authorization-cache/ClearAuthorizationCacheDialogV21';
import { ChangeChargingStationAvailabilityStatusDialogV21 } from '../change-availability/ChangeChargingStationAvailabilityStatusDialogV21';
import { TriggerChargingStationMessageDialogV21 } from '../trigger-message/TriggerChargingStationMessageDialogV21';
import { ResetDialogV21 } from './ResetDialogV21';
import { FirmwareUpdateDialog } from '../firmware-update/FirmwareUpdateDialog';

type ChargingStationV21Dialog =
  // | 'authorization21'
  | 'triggerMessage21'
  | 'availability21'
  | 'reset21'
  | 'firmwareUpdate21';

interface ChargingStationDetailsActionsV21Props {
  chargingStationDetails?: ChargingStationDetailsModel;
}

export const ChargingStationDetailsActionsV21 = ({
  chargingStationDetails,
}: ChargingStationDetailsActionsV21Props) => {
  const [openedDialog, setOpenedDialog] = useState<ChargingStationV21Dialog>();
  const chargingSationsActions = useContext(ChargingStationsActionsContext);
  const { t } = useTranslation('chargingStations');
  const navigate = useNavigate();

  return (
    chargingStationDetails && (
      <Stack gap={4} direction="row" alignItems="center" ml={4}>
        {chargingSationsActions.includes('edit') ? (
          <IconButton
            data-testid="editChargingStationPencilButton"
            onClick={() =>
              navigate(
                `${BrokerRoutes.ChargingStationDetailsGeneralTabV21}/${BrokerRoutes.EditChargingStation}`
              )
            }
          >
            <IconPencil />
          </IconButton>
        ) : null}
        <ESMenu testId={'chargingStationDetails'} disableMenu={!!openedDialog}>
          {/* <ESMenuItem
            testId={'clearAuthorizationCacheMenuItem'}
            onClick={() => setOpenedDialog('authorization21')}
          >
            {t('clearAuthorizationCache')}
          </ESMenuItem> */}
          <ESMenuItem
            testId={'triggerMessageMenuItem'}
            onClick={() => setOpenedDialog('triggerMessage21')}
          >
            {t('remoteTriggerMessage')}
          </ESMenuItem>
          <ESMenuItem
            testId={'stationResetMenuItem'}
            onClick={() => setOpenedDialog('reset21')}
          >
            {t('resetStation')}
          </ESMenuItem>
          <ESMenuItem
            testId={'stationAvailabilityMenuItem'}
            onClick={() => setOpenedDialog('availability21')}
          >
            {t('stationAvailability')}
          </ESMenuItem>
          <ESMenuItem
            testId={'firmwareUpdateMenuItem'}
            onClick={() => setOpenedDialog('firmwareUpdate21')}
          >
            {t('firmwareUpdate')}
          </ESMenuItem>
        </ESMenu>

        <ChangeChargingStationAvailabilityStatusDialogV21
          identityKey={chargingStationDetails.identityKey}
          currentStatus={chargingStationDetails.csStatus}
          isOpen={openedDialog === 'availability21'}
          onClose={() => setOpenedDialog(undefined)}
        />
        {/* <ClearAuthorizationCacheDialogV21
          identityKey={chargingStationDetails.identityKey}
          isOpen={openedDialog === 'authorization21'}
          onClose={() => setOpenedDialog(undefined)}
        /> */}
        <TriggerChargingStationMessageDialogV21
          identityKey={chargingStationDetails.identityKey}
          isOpen={openedDialog === 'triggerMessage21'}
          onClose={() => setOpenedDialog(undefined)}
        />
        <ResetDialogV21
          identityKey={chargingStationDetails.identityKey}
          isOpen={openedDialog === 'reset21'}
          onClose={() => setOpenedDialog(undefined)}
        />
        <FirmwareUpdateDialog
          identityKey={chargingStationDetails.identityKey}
          ocppProtocol={chargingStationDetails.ocppProtocol}
          isOpen={openedDialog === 'firmwareUpdate21'}
          onClose={() => setOpenedDialog(undefined)}
        />
      </Stack>
    )
  );
};
